﻿// Import Vue multiselect styles
require('vue-multiselect/dist/vue-multiselect.css');

// Import Vue datepicker styles
require('@vuepic/vue-datepicker/dist/main.css');

require('./../scss/style.scss');

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./vendor/', true, /\.js$/));
requireAll(require.context('./project/', true, /\.js$/));
